import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error("Please enter credentials");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_username", res.data.username);
      toast.success("Login successful");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "#050505" }}
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <div
            className="w-16 h-16 mx-auto mb-6 flex items-center justify-center"
            style={{ background: "rgba(212,175,55,0.1)" }}
          >
            <Lock size={24} strokeWidth={1} style={{ color: "#D4AF37" }} />
          </div>
          <h1
            className="text-3xl md:text-4xl font-medium tracking-tight mb-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Admin <span className="italic" style={{ color: "#D4AF37" }}>Portal</span>
          </h1>
          <p className="text-sm" style={{ color: "#A3A3A3", fontFamily: "'Manrope', sans-serif" }}>
            Sign in to manage buyer registrations
          </p>
        </div>

        <form
          onSubmit={handleLogin}
          data-testid="admin-login-form"
          className="glass-card p-8 md:p-10"
        >
          <div className="flex flex-col gap-6">
            <div>
              <Label className="text-xs tracking-[0.15em] uppercase mb-3 block" style={{ color: "#A3A3A3" }}>
                Username
              </Label>
              <Input
                data-testid="input-admin-username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                className="luxury-input h-12 text-base text-white placeholder:text-white/30 border-0 rounded-none bg-white/[0.03]"
                style={{ borderBottom: "1px solid rgba(255,255,255,0.15)" }}
              />
            </div>
            <div>
              <Label className="text-xs tracking-[0.15em] uppercase mb-3 block" style={{ color: "#A3A3A3" }}>
                Password
              </Label>
              <Input
                data-testid="input-admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="luxury-input h-12 text-base text-white placeholder:text-white/30 border-0 rounded-none bg-white/[0.03]"
                style={{ borderBottom: "1px solid rgba(255,255,255,0.15)" }}
              />
            </div>
          </div>

          <button
            type="submit"
            data-testid="admin-login-submit-btn"
            disabled={loading}
            className="w-full mt-8 py-4 text-xs tracking-[0.2em] uppercase font-semibold transition-all duration-300 hover:-translate-y-1 disabled:opacity-50"
            style={{ background: "#D4AF37", color: "#000", fontFamily: "'Manrope', sans-serif" }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="text-xs text-center mt-8" style={{ color: "#666", fontFamily: "'Manrope', sans-serif" }}>
          Elysian Heights Admin Portal
        </p>
      </div>
    </div>
  );
}
